export function isSvgFileName(value) {
    if (typeof value !== "string") {
        return false;
    }
    return value.toLowerCase().endsWith(".svg");
}
//# sourceMappingURL=isSvgFileName.js.map